import styled from 'styled-components';

type Props = {
    isDynamicWidth?: boolean
  }

export const DropdownWrapper = styled.div`
    .form-control {
        border: none;
        width: 100px;
        margin: 21px 0 0 3px;
        padding: 0;
        color: #1175B5;
    }

    .form-group {
        margin-bottom: 0px;
    }
`;

export const DropdownComponentWrapper = styled.div`
    &&& {
        display: flex;
    }
`;

export const InsufficientPowerButtonWrapper = styled.div`
    &&& {
        display: flex;
    }
`;
export const DynamicWidthWrapper = styled.div<Props>`
    &&& .carousel-control-wrapper {
        max-width: ${({ isDynamicWidth }) => (isDynamicWidth ? '75%' : '100%')};
    }
`;
